<template>
  <nav-bar title="钢瓶托管管理" />
  <cylinder-management />
  <van-search
    v-model="words"
    placeholder="钢瓶查询"
    input-align="center"
    @search="onSearch"
  />
  <Content :bottom="76" :top="182" @content-scroll="handleContentScroll">
    <Loading v-show="showLoading" :isLoading="isLoading" @reload="getList" />
    <ul v-if="list.length" class="code-list">
      <van-checkbox-group v-model="checked" ref="checkboxGroup">
        <li v-for="item in list" :key="item.gsId" class="code-list-item">
          <div class="code-list-item__title">
            {{ item.gsCode }}
          </div>
          <div style="margin-right: 20px">
            {{ item.custodyFlagName
            }}{{ item.custodyFlag === '2' ? `-${item.custodyUnit}` : '' }}
          </div>
          <van-checkbox :name="item.gsId" shape="square" />
        </li>
      </van-checkbox-group>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="reload()"
    />
  </Content>
  <div v-show="!showLoading" class="btn-conatiner van-hairline--top">
    <van-button
      block
      type="primary"
      native-type="button"
      :disabled="!checked.length"
      @click="handleSubmitClick"
    >
      钢瓶托管<span v-show="checked.length">（{{ checked.length }}）</span>
    </van-button>
  </div>
  <CustodyPopup
    ref="custodyPopup"
    :checked="checked"
    :list="list"
    @update="onUpdate"
  />
</template>

<script>
import { ref, computed } from 'vue'
import { Toast } from 'vant'
import { getCylinderMessListByDeptId } from '@/api/steelCylinder'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useStore } from 'vuex'
import CustodyPopup from './components/CustodyPopup..vue'
export default {
  name: 'CylinderCustodyManagementDetail', // 钢瓶托管管理
  props: ['gid', 'did'],
  components: { CustodyPopup },
  setup(props) {
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const groupId = ref('')

    // 选择钢瓶
    const checked = ref([])

    // 启用钢瓶
    const btnLoading = ref(false)
    const custodyPopup = ref(null)
    const handleSubmitClick = () => {
      custodyPopup.value.popup.showPopup()
    }

    // base
    const words = ref('')
    const searchWord = ref('') // 搜索关键词
    const data = useLoadingMore(getCylinderMessListByDeptId)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.page = 1
      pageParams.keyWord = searchWord.value
      pageParams.companyId = companyId.value
      pageParams.groupId = props.gid
      pageParams.deptId = props.did
      finished.value = false
      loadingFail.value = false
      checked.value = []
      getList()
    }
    init()

    // search
    const onSearch = (value) => {
      searchWord.value = value
      init()
      words.value = ''
    }
    const loading = ref(false)
    const onUpdate = () => {
      Toast.success('操作成功')
      onSearch()
    }
    return {
      ...data,
      words,
      onSearch,
      checked,
      handleSubmitClick,
      loading,
      groupId,
      companyId,
      btnLoading,
      custodyPopup,
      onUpdate
    }
  }
}
</script>

<style lang="scss" scoped>
.form ::v-deep(.van-cell) {
  padding-top: 0;
}
.van-search {
  padding: 0 16px 16px 16px;
}
.code-list {
  padding: 16px 16px 0 16px;
  .code-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    &__title {
      flex: 1;
      margin-right: 10px;
    }
  }
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
